/// <reference path='../../modules/app.module.ts'/>
/// <reference path="../../controllers/shell.controller.ts" />

module App {
    var getRoutes = (): App.Interfaces.ICustomState[] => {
        var route: App.Interfaces.ICustomState = {
            name: Constants.routeKeys.default,
            url: '',
            cache: false,
            title: 'Default',
            headerTitle: 'Default',
            configuratorStepName: [''],
            order: 1,
            abstract: true,
            operations: [''],
            views: {
                [Constants.viewRegions.appContent]: {
                    templateUrl: '/templates/shell.html',
                    controller: Controllers.ShellController.controllerId + ' as shellVm'
                }
            },
            showInMenu: true
        }

        return [route];
    }

    function appRun(routehelper: Blocks.Interfaces.IRouterFactory) {
        routehelper.configureRoutes(getRoutes());
    }
    
    App.Core.appCore.run(appRun);
}